/**
 * Filings Awaiting Review (/lien/awaiting-review)
 *
 * Default leaf for the Lien Filings nav group. Renders the canonical
 * UCCFilings page with its Status filter seeded to `draft`, so FI staff land
 * on the queue of filings produced by the FI pledge approval flow that their
 * institution reviews before they go to the filing office.
 *
 * Sprint B Lane B2 (2026-05-17): the audit determined that initial filings
 * should be auto-populated from FI pledge approvals, not manually created
 * via the "+ New Filing" button on /collateral/ucc-filings. This route makes
 * that workflow the default surface; the manual amendment / continuation
 * action remains accessible from /collateral/ucc-filings (Our Filings).
 *
 * A filing queued from pledge approval and not yet sent to the filing office
 * is `draft`. The ucc-filing service creates every filing as `draft`
 * (aaim-core services/ucc-filing filing-repository.ts create) and its state
 * machine moves `draft` only to `submitted`, which is the filing office's
 * queue (`submitted` goes on to acknowledged, rejected or lapsed). Filing
 * Status reads the statuses the same way. This page seeded `submitted` until
 * UI run r3 (fi-g5-1), so it showed filings already sent and never the drafts
 * awaiting review. The spec's FilingStatus enum carries no value descriptions;
 * adding them is a spec change for the operator.
 */

import { UCCFilingsPage } from '../collateral/UCCFilings';

export function FilingsAwaitingReview() {
  // No in-page heading: PortalLayout registers 'Filings Awaiting Review' as the
  // top-bar title for /lien/awaiting-review, and AppHeader renders it as the
  // page's h1.
  return (
    <UCCFilingsPage
      subtitleOverride="Auto-populated queue of UCC filings from approved pledges that your institution reviews before submission to the filing office."
      defaultStatusFilter="draft"
      defaultFilterEmptyState={{
        title: 'No filings are awaiting review',
        description: 'Filings are queued here when a pledge is approved.',
      }}
    />
  );
}
